/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EventLevelEnum } from './eventLevelEnum';
import { TaskResourceType } from './taskResourceType';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface EventsResponse { 
    id?: string;
    type?: string;
    level?: EventLevelEnum;
    sub_type?: string;
    /**
     * Org id
     */
    org_id?: string;
    org_name?: string;
    org_type?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * User who triggered the event.
     */
    created_by?: string;
    event_type_desc?: string;
    event_sub_type_desc?: string;
    /**
     * Time at which the event was generated
     */
    generated_at?: Date;
    resource_id?: string;
    resource_type?: TaskResourceType;
    /**
     * Task id
     */
    task_id?: string;
}
export namespace EventsResponse {
}


